/*
 * VULCAN
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { PortalContext } from "./portalContext";
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    /**
     * Initializes a new instance of the Portal class.
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    function Portal(credentials, options) {
        var _this = _super.call(this, credentials, options) || this;
        _this.roadmaps = new operations.Roadmaps(_this);
        _this.statusPages = new operations.StatusPages(_this);
        return _this;
    }
    return Portal;
}(PortalContext));
// Operation Specifications
export { Portal, PortalContext, Models as PortalModels, Mappers as PortalMappers };
export * from "./operations";
//# sourceMappingURL=portal.js.map